import { render, staticRenderFns } from "./allGameViewVue.vue?vue&type=template&id=1541ad1b&scoped=true"
import script from "./allGameViewVue.vue?vue&type=script&lang=js"
export * from "./allGameViewVue.vue?vue&type=script&lang=js"
import style0 from "./allGameViewVue.vue?vue&type=style&index=0&id=1541ad1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541ad1b",
  null
  
)

export default component.exports